import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { cashfree } from '../util/cashfree'
import { useParams } from 'react-router-dom';

const Cashfree = () => {
    const params = useParams()
    const isSessionId = params.sessionid
    const [loading, setLoading] = useState('');
    const [order_id, setOrderId] = useState('')
    const [sessionId, setSessionId] = useState('');
    let version = cashfree.version();

    const getSessionId = (e) => {
        e.preventDefault();
        setLoading(true);
        axios.post('https://connect-admin-andn.onrender.com/coinPlan/payment', { version })
            .then((res) => {
                setLoading(false);
                setSessionId(res.data.session_id);
                // window.open(res.data, '_blank');
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            })
    }

    const handlePayment = () => {
        let checkoutOptions = {
            paymentSessionId: sessionId,
            returnUrl: `https://connect-admin-andn.onrender.com/coinPlan/status/${order_id}`,

        }
        cashfree.checkout(checkoutOptions).then(function (result) {
            if (result.error) {
                alert(result.error.message);
            }
            if (result.redirect) {
                console.log("Redirection")
                console.log(result);
            }
        });
    }

    useEffect(() => {
        setSessionId(isSessionId)
    }, [isSessionId])

    return (
        <>
            <div className='main'>
                <div className='card px-5 py-4 mt-5'>
                    <form onSubmit={getSessionId}>
                        <input type="text" value={sessionId} onChange={(e) => { setSessionId(e.target.value) }} />
                        {!loading ? <div className='col-12 center'>
                            <button className='w-100 ' type="submit">getSessionID</button>
                        </div>
                            :
                            <div className='col-12 center'>
                                <button className='w-100 text-center' type="submit">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden ">Wait...</span>
                                    </div>
                                </button>
                            </div>
                        }
                    </form>
                    <div className='col-12 center'>
                        <button className='w-100 ' type="submit" onClick={handlePayment}>Pay Now</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Cashfree